import React from "react";
import { Tooltip, Typography } from "@arco-design/web-react";

const { Text } = Typography;

const CustomTooltip = ({ content, children, textStyle = {} }) => {
  return (
    <Tooltip content={content}>
      <Text style={{ ...textStyle }}>{children}</Text>
    </Tooltip>
  );
};

export default CustomTooltip;
